import React from 'react';

function MockContextMenu({ 
  fieldType = "string", 
  hasActiveFilter = false, 
  highlightItem = null,
  showFilterInput = null // Add this: 'text', 'greater', 'between', etc.
}) {
  const fieldDataType = (["integer", "decimal", "date"].includes(fieldType)) ? "numerical" : fieldType;

  // Helper function to apply highlight styling
  const getItemStyle = (itemName) => {
    if (highlightItem === itemName) {
      return {
        border: '2px solid var(--theme-accent)',
        borderRadius: '4px',
        backgroundColor: 'var(--theme-accent-tint)',
        boxShadow: '0 0 8px var(--theme-ring)',
        position: 'relative',
        zIndex: 1
      };
    }
    return {};
  };

  // Helper function to apply selected filter styling
  const getFilterItemStyle = (itemType) => {
    if (showFilterInput === itemType) {
      return {
        backgroundColor: 'var(--theme-accent-tint)',
        borderLeft: '3px solid var(--theme-accent)',
        fontWeight: '600',
        color: 'var(--theme-accent-ink)'
      };
    }
    return {};
  };

  return (
    <div 
      className="context-menu-content"
      style={{ 
        maxHeight: "400px", 
        overflowY: "auto",
        pointerEvents: "none",
        opacity: 0.95
      }}
    >
      {/* Sort Option */}
      <div className="context-menu-item" style={getItemStyle('sort')}>
        Sort
      </div>

      <div className="context-menu-separator" />

      {/* Filter Options */}
      <div className="context-menu-group">
        <div className="context-menu-label" style={getItemStyle('filter-label')}>Filter</div>
        
        <div 
          className="context-menu-item" 
          style={{...getItemStyle('filter-text'), ...getFilterItemStyle('text')}}
        >
          {fieldType === "string" ? "Text contains" : "Equals"}
        </div>
        
        {fieldDataType === "numerical" && (
          <>
            <div 
              className="context-menu-item" 
              style={{...getItemStyle('filter-greater'), ...getFilterItemStyle('greater')}}
            >
              {fieldType === "date" ? "Date is after" : "Greater than"}
            </div>
            <div 
              className="context-menu-item" 
              style={{...getItemStyle('filter-greater-equal'), ...getFilterItemStyle('greater-equal')}}
            >
              {fieldType === "date" ? "Date is on or after" : "Greater than or equal to"}
            </div>
            <div 
              className="context-menu-item" 
              style={{...getItemStyle('filter-less'), ...getFilterItemStyle('less')}}
            >
              {fieldType === "date" ? "Date is before" : "Less than"}
            </div>
            <div 
              className="context-menu-item" 
              style={{...getItemStyle('filter-less-equal'), ...getFilterItemStyle('less-equal')}}
            >
              {fieldType === "date" ? "Date is on or before" : "Less than or equal to"}
            </div>
            <div 
              className="context-menu-item" 
              style={{...getItemStyle('filter-between'), ...getFilterItemStyle('between')}}
            >
              {fieldType === "date" ? "Date is between" : "Between"}
            </div>
          </>
        )}
      </div>

      {/* Filter Input Fields - shown when showFilterInput is set */}
      {showFilterInput && (
        <div className="p-2 space-y-2" style={getItemStyle('filter-input')}>
          <input
            className="w-full px-3 py-2 border rounded"
            type={(() => {
              switch(fieldType) {
                case "string": return "text";
                case "integer": return "number";
                case "decimal": return "number";
                case "date": return "date";
                default: return "text";
              }
            })()}
            placeholder={fieldType === "date" ? "Select date" : "Enter value"}
            disabled
            style={{ backgroundColor: '#f9fafb', cursor: 'not-allowed' }}
          />
          
          {showFilterInput === "between" && (
            <input
              className="w-full px-3 py-2 border rounded"
              type={fieldType === "date" ? "date" : "number"}
              placeholder={fieldType === "date" ? "Select end date" : "Enter second value"}
              disabled
              style={{ backgroundColor: '#f9fafb', cursor: 'not-allowed' }}
            />
          )}
          
          <button 
            className="mt-2 w-full rounded py-2 px-4 text-white font-medium"
            disabled
            style={{ 
              backgroundColor: 'var(--theme-accent)',
              cursor: 'not-allowed',
              opacity: 0.9,
              ...getItemStyle('apply-filter-button')
            }}
          >
            Apply Filter
          </button>
        </div>
      )}

      {/* Clear Filter Buttons - only show if hasActiveFilter */}
      {hasActiveFilter && (
        <>
          <div className="context-menu-item text-red-600" style={getItemStyle('clear-filter')}>
            Clear Filter
          </div>
          <div className="context-menu-item text-red-600" style={getItemStyle('clear-all-filters')}>
            Clear All Filters
          </div>
        </>
      )}

      <div className="context-menu-separator" />

      {/* Column Visibility Options */}
      <div className="context-menu-item" style={getItemStyle('show-hide-columns')}>
        Show/Hide Columns
      </div>
      <div className="context-menu-item" style={getItemStyle('hide-column')}>
        Hide This Column
      </div>
    </div>
  );
}

export default MockContextMenu;